module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: ("social-button network-" + _vm.network),
    domProps: {
      "innerHTML": _vm._s(_vm.image[_vm.network])
    },
    on: {
      "click": _vm.handleClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-596ffc48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SocialButton.vue
// module id = 164
// module chunks = 2